export function PriceFormat(price = 0, abs = true): string {
  let _price = price;

  const priceFormat = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });

  if (abs) {
    _price = Math.abs(price);
  }

  return priceFormat.format(_price);
}
